import request from '@/utils/request'
import md5 from 'js-md5'
// 查询用户列表 GET /api/user/qryUser
export function qryUser(query) {
  var query_ = {}
  query_.pageIndex = query.pageIndex
  query_.pageSize = query.pageSize
  if (query.roleId !== null) {
    query_.roleId = query.roleId
  }
  if (query.userNameOrLoginNo) {
    query_.userNameOrLoginNo = query.userNameOrLoginNo
  }
  return request({
    url: '/api/user/qryUser',
    method: 'get',
    params: query_
  })
}
// 添加用户 /POST /api/user/addUser
export function addUser(query) {
  return request({
    url: '/api/user/addUser',
    method: 'post',
    data: query
  })
}
// 修改用户信息 /api/user/modUser
export function modUser(query) {
  return request({
    url: '/api/user/modUser',
    method: 'post',
    data: query
  })
}
// 修改密码 /api/user/UpdatePassWord
export function UpdatePassWord(query) {
  const data = {
    userId: query.userId,
    pwd: md5(query.pwd)
  }
  return request({
    url: '/api/user/UpdatePassWord',
    method: 'post',
    params: {
      userId: data.userId,
      pwd: data.pwd
    }
  })
}
// 查询用户信息
export function qryUserInfo(query) {
  return request({
    url: '/api/user/qryUser',
    method: 'get',
    params: query
  })
}
// 查询运营人员/api/user/SearchOperationUser
export function SearchOperationUser() {
  return request({
    url: '/api/user/SearchOperationUser',
    method: 'post'
  })
}

// GET /api/user/QryAccountDetail 查询账户变动
export function QryAccountDetail(query) {
  return request({
    url: '/api/user/QryAccountDetail',
    method: 'get',
    params: query
  })
}

// POST /api/user/updateFieldUserDevPassword 修改场地方设备密码
export function updateFieldUserDevPassword(params) {
  return request({
    url: '/api/user/updateFieldUserDevPassword',
    method: 'post',
    params
  })
}

// POST /api/user/setWithDrawWay 设置用户提现方式
export function setWithDrawWay(data) {
  return request({
    url: '/api/user/setWithDrawWay',
    method: 'post',
    data
  })
}

// POST /api/user/clearUserOpenId 清除场地方，代理商OpenId
export function clearUserOpenId(data) {
  return request({
    url: '/api/user/clearUserOpenId',
    method: 'post',
    data
  })
}

/**
 *POST /api/user/delUser 删除用户
 */
export function delUser(data) {
  return request({
    url: '/api/user/delUser',
    method: 'post',
    data
  })
}

// POST /api/user/modUserMaxUseCount 修改用户最大使用次数
export function modUserMaxUseCount(data) {
  return request({
    url: '/api/user/modUserMaxUseCount',
    method: 'post',
    data
  })
}

